import classNames from "classnames"
import "./tabs.css"
import { Link, useLocation } from "wouter"
import { useWatcher } from "../../lib/state/useWatcher"
import { TenantFeature, tenantState } from "../../store/tenant"
import { UserRole } from "src/types"
import { userState } from "@/store/user"
import { hasUserAccess } from "@/utils/user"

export type Tab = {
  id: string
  title: string
  neededRole: UserRole
  hideInTabs?: boolean
  features?: TenantFeature[]
  Component?: any // TODO :D
}
type Props = {
  tabs: Tab[]
}

export const Tabs = ({ tabs }: Props) => {
  const [location] = useLocation()
  const {
    settings: { features },
  } = useWatcher(tenantState)
  const user = useWatcher(userState)
  return (
    <div className="tabs wrap">
      <div className="tabs-inner">
        {tabs.map((tab) => {
          if (tab.hideInTabs) {
            return null
          }
          if (
            tab.features &&
            !tab.features.every((feature) => features[feature])
          ) {
            return null
          }
          if (
            tab.neededRole != null &&
            !hasUserAccess({
              neededRole: tab.neededRole,
              userRole: user.role,
            })
          ) {
            return null
          }
          return (
            <Link to={tab.id} key={tab.id}>
              <div
                className={classNames("tab", {
                  active: location.startsWith(tab.id),
                })}
              >
                {tab.title}
              </div>
            </Link>
          )
        })}
      </div>
      <div id="tabs-right" />
    </div>
  )
}
